/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */

import * as constants from '../constants'

export const poiWhitelist = Object.values(constants)
